import React from "react";

// A labeled divider for grouping blocks ("During shift", "End of day").
// Becomes a section heading in the daily email.
function SectionHeaderBlock(props) {
  return (
    <div className="w-full pt-2">
      <p className="text-sm font-bold uppercase tracking-wider text-slate-500">
        {props.block.config?.label || ""}
      </p>
    </div>
  );
}

export default SectionHeaderBlock;
